import { Link, Navigate } from 'react-router-dom';
import { ArrowRightIcon, Button } from '../../../components';
import { useNextTask } from '../utils/hooks';
import backgroundImage from '../../../assets/tasks-framework/tasks-framework-resolver-generic-intro.svg';

export const ResolverIntroGeneric = () => {
  const nextTask = useNextTask();

  if (!nextTask) {
    return <Navigate to="/home" replace />;
  }

  return (
    <section className="mx-auto flex w-max rounded-md bg-sage-200">
      <div className="grow p-9">
        <h1 className="mb-2 text-2xl font-bold">Tasks Detected</h1>
        <p>Let&apos;s resolve those outstanding tasks.</p>

        <Button
          className="mt-9"
          as={Link}
          to={`task/${nextTask.id}`}
          rightIcon={<ArrowRightIcon className="size-4" />}
        >
          Get Started
        </Button>
      </div>

      <img src={backgroundImage} alt="" className="object-cover" />
    </section>
  );
};
